import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Member from './Member';
import { AccordianList } from '../../../../common/AccordianList';
import AddMembers from '../../Modals/AddMembers';
import { openCustomModal } from '../../../../actions/modal';

function MemberList({ conversationId, detailsInfo, numberOfItemToShow = 3 }) {
    const dispatch = useDispatch();
    const chatDetails = useSelector((state) => state.chat.chatDetails);

    const memoizedChatDetails = useMemo(() => {
        return chatDetails[conversationId] || {};
    }, [chatDetails, conversationId]);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const isAdmin = useMemo(() => {
        if (memoizedChatDetails && Array.isArray(memoizedChatDetails.members)) {
            return memoizedChatDetails.members.find((mem) => mem.id === newLoggedUserData.user.id && mem.role === 'ADMIN')
        }
        return false;
    }, [memoizedChatDetails, newLoggedUserData]);

    const onAddMemberCLick = () => {
        let heading = 'Add Member';
        let modalWidth = '55rem';
        let modalHeight = 'auto';
        let modalComponent = <AddMembers org_id={memoizedChatDetails?.org_id || newLoggedUserData.org.id} conversationId={conversationId} members={memoizedChatDetails?.members} />;
        dispatch(openCustomModal({ heading, modalWidth, modalHeight, modalComponent }));
    };

    const membersLength = Array.isArray(memoizedChatDetails?.members) ? `(${memoizedChatDetails?.members?.length})` : '';

    return (
        <div className="p-6 border-t border-gray-200 bg-white rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-5">
                <h3 className="text-lg font-semibold text-scogoprimary flex items-center">
                    <span className="material-icons mr-2 text-scogoprimary text-font16">group</span>
                    Members <span className="ml-1 text-sm font-medium text-gray-500">{membersLength}</span>
                </h3>
                <button
                    onClick={() => onAddMemberCLick()}
                    className="flex items-center text-xs font-medium text-scogoprimary hover:text-scogoorange transition-colors duration-200 px-3 py-1 rounded-full border border-gray-200 hover:border-scogoorange"
                >
                    <span className="material-icons text-font14 mr-1">person_add</span>
                    Add Members
                </button>
            </div>

            <div className="mt-4">
                <AccordianList
                    list={memoizedChatDetails?.members || []}
                    ItemComponent={Member}
                    numberOfItemToShow={numberOfItemToShow}
                    showMoreTitle='Show All Members'
                    itemProps={{
                        conversationId,
                        groupName: detailsInfo?.conversationName,
                        chatType: detailsInfo?.type,
                        admin: { admin: isAdmin }
                    }}

                />
            </div>
        </div>
    );
}

export default MemberList;
